export const quiz = [
    {
        id : 1,
        pertanyaan : "Disebuah kantin sekolah, Adul dan kawan-kawan membayar tidak lebih dari Rp35.000 untuk 4 bungkus mie sakura dan 6 gelas es yang dipesannya, sedangkan Palui dan kawan-kawan membayar tidak lebih dari Rp50.000 untuk 8 bungkus mie sakura dan 4 gelas es. Jika kita memesan 5 bungkus mie sakura dan 3 gelas es maka maksimum yang harus kita bayar adalah ....",
        options : [
            { 
                title : "Rp27.500,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp30.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp32.500,00",
                op :"c",
                correct : true,
            },
            { 
                title : "Rp35.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp37.500,00",
                op :"e",
                correct : false,
            },
        ],                
    },
    {
        id : 2,
        pertanyaan : "Pak Andi akan membuka usaha dengan berjualan ikan cupang halfmoon dan ikan cupang crowntail di kiosnya dengan isi paling sedikit 30 soliter cupang halfmoon dan paling sedikit 40 soliter cupang crowntail. Kios tersebut dapat menampung 120 soliter. Bila keuntung untuk setiap ikan cupang masing-masing adalah Rp10.000,00 dan Rp15.000,00 keuntungan terbesar yang dapat diperoleh Pak Andi adalah ....",
        options : [
            { 
                title : "Rp1.400.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp1.600.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp1.650.000,00",
                op :"c",
                correct : true,
            },
            { 
                title : "Rp1.800.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp2.100.000,00",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 3,
        pertanyaan : "Ibu Yati memproduksi dua jenis keripik pisang,yaitu rasa coklat dan rasa keju. Setiap kilogram keripik pisang rasa coklat membutuhkan modal Rp100.000,00 sedangkan keripik rasa keju membutuhkan modal Rp150.000,00 per kilogram dan maksimum modal adalah Rp5.000.000,00. Tiap hari hanya bisa memproduksi paling banyak 40 kilogram. Keuntungan tiap kilogram keripik pisang rasa cokelat Rp25.000,00 dan keripik pisang rasa keju Rp30.000,00 per kilogram. Keuntungan terbesar yang dapat diperoleh ibu Yati adalah ....",
        options : [
            { 
                title : "Rp1.100.000,00",
                op :"a",
                correct : true,
            },
            { 
                title : "Rp1.000.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp990.000,00",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp890.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp850.000,00",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 4,
          pertanyaan : "Amin merpukan seorang pemilik toko sepatu ingin mengisi tokonya dengan sepatu laki-laki paling sedikit 100 pasang dan sepatu wanita paling sedikit 150 pasang. Toko tersebut dapat memuat 400 pasang sepatu. Keuntungan setiap sepatu laki-laki Rp10.000,00 dan setiap sepasang sepatu wanita Rp5.000,00. Jika banyaknya sepatu laki-laki tidak boleh melebihi 150 pasang maka keuntungan terbesar yang didapat Amin adalah ....",
        options : [
            { 
                title : "Rp2.750.000,00",
                op :"a",
                correct : true,
            },
            { 
                title : "Rp3.000.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp3.250.000,00",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp3.500.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp3.750.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 5,
        pertanyaan : "Renaldi adalah seorang pedagang sepeda ingin membeli 25 sepeda untuk persediaan. Renaldi ingin membeli sepeda merk A dengan harga Rp1.500.000,00 per buah dan sepeda merk B dengan harga Rp2.000.000,00 per buah. Renaldi merencanakan tidak akan mengeluarkan uang lebih dari Rp42.000.000,00. Jika keuntungan sebuah sepeda merk A seharga Rp500.000,00 dan sebuah sepeda merk B seharga Rp600.000,00, maka keuntungan maksimum yang diterima Renaldi adalah ....",
        options : [
            { 
                title : "Rp13.400.000,00 ",
                op :"a",
                correct : true,
            },
            { 
                title : "Rp12.600.000,00 ",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp13.600.000,00 ",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp10.400.000,00 ",
                op :"d",
                correct : false,
            },
            { 
                title : "8.400.000,00 ",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id: 6,
        pertanyaan : "Sebuah toko bunga menjual 2 macam rangkaian bunga. Rangkaian 1 memerlukan 10 tangkai bunga mawar dan 15 tangkai bunga anyelir. Rangkaian 2 memerlukan 20 tangkai bunga mawar dan 5 tangkai bunga anyelir. Persediaan bunga mawar dan bunga anyelir masing-masing 200 tangkai dan 100 tangkai. Jika rangkaian 1 seharga Rp200.000,00 per rangkaian dan rangkaian 2 dijual Rp100.000,00 per rangkaian, maka penghasilan maksimum yang dapat diperoleh toko tersebut adalah ....",
        options : [
            { 
                title : "Rp1.400.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp1.500.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp1.600.000,00",
                op :"c",
                correct : true,
            },
            { 
                title : "Rp1.700.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp1.800.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 7,
        pertanyaan : "Amrina merupakan seorang penjahit, dia akan membuat 2 model pakaian. Dia mempunyai persediaan kain batik 40 meter dan kain polos 15 meter. Model A memerlukan 1 meter kain batik dan 1,5 meter kain polos sedangkan model B memerlukan 2 meter kain batik dan 0,5 meter kain polos. Maksimum banyak pakaian yang mungkin dibuat adalah ....",
        options : [
            { 
                title : "10",
                op :"a",
                correct : false,
            },
            { 
                title : "20",
                op :"b",
                correct : false,
            },
            { 
                title : "22",
                op :"c",
                correct : true,
            },
            { 
                title : "25",
                op :"d",
                correct : false,
            },
            { 
                title : "30",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 8,
        pertanyaan : "Sebuah pesawat terbang mempunyai 60 tempat duduk. Setiap penumpang kelas utama boleh membawa barang hingga 50kg, sedangkan untuk setiap penumpang kelas ekonomi boleh membawa barang 20kg. Bagasi pesawat itu hanya mampu menampung barang seberat 1.150kg. Jika harga tiket kelas utama Rp500.000,00 dan untuk harga tiket kelas ekonomi Rp300.000,00, pendapatan maksimum untuk sekali penerbangan adalah ....",
        options : [
            { 
                title : "Rp15.000.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp18.000.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp20.000.000,00",
                op :"c",
                correct : true,
            },
            { 
                title : "Rp22.000.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "30.000.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 9,
        pertanyaan : "Amin seorang pedagang pakaian, dia menjual dua jenis pakaian yaitu kemeja dan celana panjang. Harga beli kemeja adalah Rp100.000,00 yang akan dijual dengan harga Rp120.000,00 per potong, sedangkan harga beli celana panjang adalah Rp150.000,00 yang dijual dengan harga Rp175.000,00 per potong. Modal yang dimiliki adalah Rp30.000.000,00 dan toko pakaian tersebut hanya dapat memuat 250 potong pakaian. Keuntungan maksimum yang didapat Amin jika ia menjual  ...",
        options : [
            { 
                title : "150 kemeja dan 100 celana panjang",
                op :"a",
                correct : true,
            },
            { 
                title : "100 kemeja dan 150 celana panjang",
                op :"b",
                correct : false,
            },
            { 
                title :"250 kemeja dan 200 celana panjang",
                op :"c",
                correct : false,
            },
            { 
                title : "250 kemeja saja",
                op :"d",
                correct : false,
            },
            { 
                title : "250 celana panjang saja",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 10,
        pertanyaan :"Rika merupakan seorang pedagang makanan yang menggunakan gerobak menjual pisang keju dan sukun. Harga pembelian untuk pisang keju Rp1.000,00/biji dan sukun Rp400,00/biji. Jika keuntungan dari pisang keju Rp500,00/biji dan sukun Rp300,00/biji, keuntungan maskimum yang dapat diperoleh Rika adalah ....",
        options : [
            { 
                title : "Rp150.000,00",
                op :"a",
                correct : true,
            },
            { 
                title : "Rp165.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp175.000,00",
                op :"c", 
                correct : false,
            },
            { 
                title : "Rp187.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp200.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },    

];